import React from 'react';
import PropTypes from 'prop-types';
import useCheckDepartment from '../../../../../hooks/shared/custom/check-department/useCheckDepartment';
import { LOGGED_IN_USER_URL } from '../../../../../services/api/auth/AuthUrl';
import { ADMIN_DEPARTMENT } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AdminDeptNavBar from '../../../../layouts/admin-department/AdminDeptNavBar';
import PurchaseOrderBody from '../../../shared/purchase-order/PurchaseOrderBody';

const AdminDeptPurchaseOrder = ({ history }) => {
  useCheckDepartment(`${LOGGED_IN_USER_URL}`, `${ADMIN_DEPARTMENT}`, history);
  const {
    profile: { firstName, department_id },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AdminDeptNavBar currentPage="Purchase Order" position={firstName} />
        <div className="container">
          <PurchaseOrderBody deptID={department_id} />
        </div>
      </main>
    </div>
  );
};

AdminDeptPurchaseOrder.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default AdminDeptPurchaseOrder;
